// allContext.js
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import React, { createContext, useContext } from 'react';
import camelcaseKeys from "camelcase-keys";

import { API_BASE_URL, BOOK_LIST } from '../Utilities/constant';
import { resetSelectedAll, unauthorized, setRead, resetHasNote, replaceTabVerseListNewItem, verseList2verseListNew, replaceHasNoteVersesChild, circularProgressTextUpdate } from '../Utilities/common';

import reducer from '../Imports/reducerImports';
import { setErrorResponse } from '../Redux/homeReducer';

const allContext = createContext();

export const Shared = ({ children }) => {
  
  const { setPageNumberNoteSearch, setButtonText, setCallerConfirmationDialog, setDialogTitle, setTitleToBeDeleted, setSearchHttpPostData, setTabVerseListNew, setSelectedVerses,  reset4SignIn, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setChecked, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setOpen4, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setFontSize, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setLastName, setLastNameError, setLastNameErrorMessage, setFirstName, setFirstNameError, setFirstNameErrorMessage, setCountry, setCountryError, setCountryErrorMessage, setEmail, setEmailError, setEmailErrorMessage, setUsername4Profile, setUsernameError4Profile, setUsernameErrorMessage4Profile, setPassword4Profile, setPasswordError4Profile, setPasswordErrorMessage4Profile, setAgeRange4Profile, setAgeRangeError4Profile, setAgeRangeErrorMessage4Profile, setGender4Profile, setGenderError4Profile, setGenderErrorMessage4Profile, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;

  const dispatch = useDispatch(); // dispatch(
  const credential = useSelector((state) => state.signIn.credential);
  const circularProgressText = useSelector((state) => state.home.circularProgressText);  
  const historyListItemSelected = useSelector((state) => state.dialog2.historyListItemSelected);
  // const confirmedBookChapterList = useSelector((state) => state.home.confirmedBookChapterList);
  const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);
  const book4Accordion1 = useSelector((state) => state.noteBookmarkVerseList.book4Accordion1);
  const chapter4Accordion1 = useSelector((state) => state.noteBookmarkVerseList.chapter4Accordion1); 
  const bookChapter = useSelector((state) => state.home.bookChapter); 
  const pageNumberNote = useSelector((state) => state.noteBookmarkList.pageNumberNote);
  const pageNumberNoteSearch = useSelector((state) => state.noteBookmarkList.pageNumberNoteSearch);
  const noteBookmarkListBookChapterVerse = useSelector((state) => state.noteBookmarkList.noteBookmarkListBookChapterVerse);
  const noteBookmarkVerseList = useSelector((state) => state.noteBookmarkVerseList.noteBookmarkVerseList);
  const noteBookmarkListItemToBeChanged = useSelector((state) => state.dialog4.noteBookmarkListItemToBeChanged);
  const title = useSelector((state) => state.dialog4.title);
  const details = useSelector((state) => state.dialog4.details);
  const noteBookmarkListItemToBeDeleted = useSelector((state) => state.confirmationDialog.noteBookmarkListItemToBeDeleted);
  const searchString = useSelector((state) => state.verseSearch.searchString);
  const pageNumberVerseSearch = useSelector((state) => state.verseSearch.pageNumberVerseSearch);
  const verseReadLogList4Book = useSelector((state) => state.home.verseReadLogList4Book);
  const searchScopeListItemSelected = useSelector((state) => state.verseSearch.searchScopeListItemSelected);
  const searchCriteriaListItem = useSelector((state) => state.verseSearch.searchCriteriaListItem);
  const userListItem = useSelector((state) => state.home.userListItem);
  const pageNumberSearch2 = useSelector((state) => state.noteSearch.pageNumberSearch2);
  const caller4NoteBookmarkList = useSelector((state) => state.noteBookmarkList.caller4NoteBookmarkList);
  const confirmedNoteSearchString = useSelector((state) => state.noteSearch.confirmedNoteSearchString);
  const debug = useSelector((state) => state.home.debug);  
  const errorResponse = useSelector((state) => state.home.errorResponse);  
  const bookList = useSelector((state) => state.home.bookList);

  const getTempCredential = async () => {
    try {
      const token = await getToken('tempToken', 'eyJhbGciOiJIUzI1NiIsInR5c', 5);
      if (token && token.length > 0) {
        return {
          UserName: 'tempToken',
          Token: token,
        };
      } else {
        return null; // Return null if the token is empty or invalid
      }
    } catch (error) {
      console.error('Error fetching temp credential:', error);
      return null; // Return null in case of an error
    }
  };

  const sendEmail4SignUp = async (httpPostData, componentName) => {
      try {

        const url = API_BASE_URL + 'api/UserListItem/SendEmail4SignUp/';
        await axios.post(url, httpPostData);

        if (debug) {
          let details = `Email: ${httpPostData.Email}; UserName: ${httpPostData.UserName}`;
          postLogListItem({Credential: httpPostData.Credential, FunctionName: 'sendEmail4SignUp', ComponentName: componentName, Details: details});       
        } 

      } catch (error) {
        console.log(error);
      } finally {

      } 
  }

  const sendEmail4PasswordReset = async (httpPostData, componentName) => {
      try {

        const url = API_BASE_URL + 'api/UserListItem/SendEmail4PasswordReset/';
        await axios.post(url, httpPostData);

        if (debug) {
          let details = `Email: ${httpPostData.Email}; UserName: ${httpPostData.UserName}`;
          postLogListItem({Credential: httpPostData.Credential, FunctionName: 'sendEmail4PasswordReset', ComponentName: componentName, Details: details});       
        }         

      } catch (error) {
        console.log(error);
      } finally {

      } 
  }

  const getEmailByUsername = async (httpPostData, componentName) => {

    const url = API_BASE_URL + 'api/UserListItem/Email/Get/';

    try {
      dispatch(setLoading4Home(true));
      const response = await axios.post(url, httpPostData);

      if (debug) {
        let details = `UserName: ${httpPostData.UserName}`;
        postLogListItem({Credential: httpPostData.Credential, FunctionName: 'getEmailByUsername', ComponentName: componentName, Details: details});       
      } 

      return response.data;
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }

  }

  const verifyEmail4PasswordReset = async (email, verificationToken, componentName) => {

    var v_user_list_item = {
      Email: email,
      VerificationToken4PasswordReset: verificationToken,
    };

    const url = API_BASE_URL + 'api/UserListItem/VerifyEmail4PasswordReset/';

    try {
      dispatch(setLoading4Home(true));
      const response = await axios.post(url, v_user_list_item);

      if (debug) {
        const tempCredential = await getTempCredential();
        let details = `Email: ${email}`;
        postLogListItem({Credential: tempCredential, FunctionName: 'verifyEmail4PasswordReset', ComponentName: componentName, Details: details});       
      } 

      return response.data;
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }

  }

  const verifyEmail4SignUp = async (email, verificationToken, componentName) => {

    var v_user_list_item = {
      Email: email,
      VerificationToken4SignUp: verificationToken,
    };

    const url = API_BASE_URL + 'api/UserListItem/VerifyEmail4SignUp/';

    try {
      dispatch(setLoading4Home(true));
      const response = await axios.post(url, v_user_list_item);

      if (debug) {
        const tempCredential = await getTempCredential();
        let details = `Email: ${email}`;
        postLogListItem({Credential: tempCredential, FunctionName: 'verifyEmail4SignUp', ComponentName: componentName, Details: details});       
      } 

      return response.data;
      
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }

  }

  const bookRead = (book, plusMinus) => {
    let updatedList = bookList.map(item => {
      if (item.Number === book) {
        let updatedChapterRead = item.ChapterRead + plusMinus;
        let isRead = updatedChapterRead === item.Chapters;
        return {
          ...item,
          ChapterRead: updatedChapterRead,
          Read: isRead,
        };
      }
      return item;
    });
    dispatch(setBookList(updatedList));
  };

  const unauthorized = () => {
    dispatch(setCallerConfirmationDialog('allContext'));
    //dispatch(setDialogTitle('確定登出'));
    dispatch(setButtonText('登出'));
    dispatch(setTitleToBeDeleted('401 - 操作逾時，請重新登入'));
    dispatch(setOpenConfirmationDialog(true));
  }

  const getToken = async (userName, password, minuteSecurityTokenExpire) => {

    // dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('signin')));
    //postLogListItem({Credential: credential, FunctionName: 'getToken', ComponentName: componentName, Details: null});

    var v_user_list_item = {
      UserName: userName,
      Password: password,
      MinuteSecurityTokenExpire: minuteSecurityTokenExpire,
    };

    const url = API_BASE_URL + 'api/UserListItem/Token/Get/';

    try {
      dispatch(setLoading4Home(true));
      const response = await axios.post(url, v_user_list_item);
      return response.data;
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }

  }

  const postPutSearchCriteriaListItem = async (excludedList, componentName) => {

    // if (debug) postLogListItem({Credential: credential, FunctionName: 'postPutSearchCriteriaListItem', ComponentName: componentName, Details: null});

    let url;
    let httpPostData;

    if (searchCriteriaListItem.ID > 0) { // already have SearchCriteriaListItem for this search criteria (this item will be saved only if at least one SearchCriteriaExcludedListItem is existed)
      httpPostData = {
        Credential: credential,
        ID: searchCriteriaListItem.ID,
        Value: searchString,
        SearchScopeID: searchScopeListItemSelected,
        SearchCriteriaExcludedList: excludedList,
        ExcludedTotal: excludedList.length,
        Updated: { SearchScopeID: true, ExcludedTotal: true }
      };
      url = API_BASE_URL + 'api/SearchCriteriaExcludedList/Post2/VerseList/Get/';
    } else { // searchCriteriaListItem.ID = 0, i.e. a new search criteria
      httpPostData = {
        Credential: credential,
        Value: searchString,
        SearchScopeID: searchScopeListItemSelected,
        SearchCriteriaExcludedList: excludedList,
        ExcludedTotal: excludedList.length,
      };
      url = API_BASE_URL + 'api/SearchCriteriaListItem/Post2/VerseList/Get/';
    }
    dispatch(setSearchHttpPostData(httpPostData));

    try {      

      // dispatch(setLoading4Home(true));      
      const response = await axios.post(url, httpPostData);

      if (searchCriteriaListItem.ID === 0) {

        const newId = Number(response.data.Message);

        excludedList.forEach(item => {
          item.SearchCriteriaID = newId;
        });

        const item = {
          Value: searchString,
          SearchScopeID: searchScopeListItemSelected,
          SearchCriteriaExcludedList: excludedList,
          ExcludedTotal: excludedList.length,
          ID: newId,
          PageNumber: 0,
          PageSize: 0,
          Username: userListItem.UserName,
          Valid: true,
        }

        dispatch(setSearchCriteriaListItem(item));

      }
      //getSearchCriteriaListItem('allContext');

      dispatch(setSearchResultVerseList({ResultTotal: -1, VerseList: []}));
      getSearchResultVerseList(httpPostData, 'allContext');

      if (debug) {
        let details = `searchCriteriaListItem.ID: ${searchCriteriaListItem.ID}; Value: ${searchString}`;
        postLogListItem({Credential: credential, FunctionName: 'postPutSearchCriteriaListItem', ComponentName: componentName, Details: details});       
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();      
    } finally {
      // dispatch(setLoading4Home(false)); // Set loading to false after fetching      
    }
  }

  const deleteVerseReadLogList = async ({ book }, componentName) => {
    try {

      const httpPostData = {
        Credential: credential,
        Book: book, // book = 0 for all books
        Valid: false,
        Updated: { Valid: true },
      };
      const url = API_BASE_URL + 'api/VerseReadLogList/Clear/';
      // dispatch(setLoading4Home(true));
      await axios.post(url, httpPostData);

      if (book === 0) {
        dispatch(setVerseReadLogList4Book([]));
        const updatedBookList = bookList.map(item => ({
          ...item,
          ChapterRead: 0,
          Read: false
        }));
        dispatch(setBookList(updatedBookList));
      }
      else {
        const list = verseReadLogList4Book.filter((verseReadLogListItem) => verseReadLogListItem.book !== book);
        dispatch(setVerseReadLogList4Book(list));
        const updatedBookList = bookList.map(item => 
          item.Number === book ? {...item, ChapterRead: 0, Read: false} : item
        );
        dispatch(setBookList(updatedBookList));
      }

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'deleteVerseReadLogList', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      // dispatch(setLoading4Home(false)); // Set loading to false after fetching      
    }  
  } 

  const deleteVerseReadLogListItem = async ({ book, chapter}, componentName) => {
    try {

      const httpPostData = {
        Credential: credential,
        Book: book,
        Chapter: chapter,
        Valid: false,
        Updated: { Valid: true },
      };
      const url = API_BASE_URL + 'api/VerseReadLogListItem/Put/';
      //dispatch(setLoading4Home(true));
      await axios.post(url, httpPostData);

      if (verseReadLogList4Book.length > 0) {
        if (book === verseReadLogList4Book[0].book){
          const exists = verseReadLogList4Book.some(item => item.chapter === chapter);
          if (exists){
            const list = verseReadLogList4Book.filter(item => item.chapter !== chapter);
            dispatch(setVerseReadLogList4Book(list));
          }
        }
      }

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'deleteVerseReadLogListItem', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false)); // Set loading to false after fetching      
    }  
  } 
 
  const postPutVerseReadLogListItem = async ({ book, chapter }, componentName) => {
    //dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('postPutVerseReadLogListItem')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'postPutVerseReadLogListItem', ComponentName: componentName, Details: null});
    try {

      // const credential = getCredential();
      const httpPostData = {
        Credential: credential,
        Book: book,
        Chapter: chapter
      };
      const url = API_BASE_URL + 'api/VerseReadLogListItem/Post/';
      //dispatch(setLoading4Home(true));
      await axios.post(url, httpPostData);

      if (verseReadLogList4Book.length > 0) {
        if (book === verseReadLogList4Book[0].book) {
          const exists = verseReadLogList4Book.some(item => item.chapter === chapter);
          if (!exists){
            const verseReadLogListItem ={
              book: book,
              chapter: chapter
            }
            let list = [...verseReadLogList4Book, verseReadLogListItem];
            list.sort((a, b) => a.chapter - b.chapter);
            dispatch(setVerseReadLogList4Book(list));
          }
        }
      }
      else {
        const verseReadLogListItem ={
          book: book,
          chapter: chapter
        }
        let list = [...verseReadLogList4Book, verseReadLogListItem];
        dispatch(setVerseReadLogList4Book(list));        
      }

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'postPutVerseReadLogListItem', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }
  }  
  
  const deleteLogListItem = async () => {
    try {

      const httpPostData = {
        Credential: credential,
      };
      const url = API_BASE_URL + 'api/LogListItem/Delete/';
      // dispatch(setLoading4Home(true));
      await axios.post(url, httpPostData);

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      // dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }
  }

  const postLogListItem = async (logListItem) => {
    //dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('postLogListItem')));
    try {
      const httpPostData = {
        Credential: logListItem.Credential,
        FunctionName: logListItem.FunctionName,
        ComponentName: logListItem.ComponentName,
        Details: logListItem.Details,
      };
      const url = API_BASE_URL + 'api/LogListItem/Post/';
      // dispatch(setLoading4Home(true));
      await axios.post(url, httpPostData);
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      // dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }
  }

  const postHistoryListItem = async ({ book, chapter }, componentName) => { // UserName, CreationDateTimeHK and RevisionDateTimeHK ok
    //dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('postHistoryListItem')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'postHistoryListItem', ComponentName: componentName, Details: null});
    try {

      // const credential = getCredential();
      const httpPostData = {
        Credential: credential,
        Book: book,
        Chapter: chapter
      };
      const url = API_BASE_URL + 'api/HistoryListItem/Post/';
      // dispatch(setLoading4Home(true));
      await axios.post(url, httpPostData);

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'postHistoryListItem', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //postLogListItem({Credential: credential, FunctionName: 'postHistoryListItem', ComponentName: null, Details: `book: ${book}, chapter: ${chapter}`});
      // dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }
  }

  const getHasNoteVerses = async (tabNumber, componentName) => {    

    let book = tabVerseListNew[tabNumber].book;
    let chapter = tabVerseListNew[tabNumber].chapter;

    if (book > 0 && chapter > 0) {

      try {
        const httpPostData = {
          Credential: credential,
          BibleVersion: 'CUNP',
          Book: book,
          Chapter: chapter
        };
        const url = API_BASE_URL + 'api/VerseList/HasNote2/Get/';
        // dispatch(setLoading4Home(true));
        const response = await axios.post(url, httpPostData);

        let updatedTabVerseListNewItem = resetHasNote(tabVerseListNew[tabNumber]);  

        response.data.map((verse, index) => (
          updatedTabVerseListNewItem.verses[verse-1].hasNote = true
        ))

        if (debug) {
          let details = '';
          postLogListItem({Credential: credential, FunctionName: 'getHasNoteVerses', ComponentName: componentName, Details: details});
        }  

        const newTabVerseListNewItem = { ...tabVerseListNew[tabNumber], verses: updatedTabVerseListNewItem.verses };
        const updatedTabVerseListNew = replaceTabVerseListNewItem(tabVerseListNew, tabNumber, newTabVerseListNewItem);
        dispatch(setTabVerseListNew(updatedTabVerseListNew));
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) unauthorized();
      } finally {
        // dispatch(setLoading4Home(false)); // Set loading to false after fetching  
      }  

    }     
    // dispatch(setTabVerseListNew(list));
    // dispatch(setLoading4Home(false)); // Set loading to false after fetching    
  }   

  const getHasNoteVersesAll = async (list, componentName) => {    

    let tempList = resetSelectedAll(tabVerseListNew);

    for (let tabNumber = 0; tabNumber < 4; tabNumber++) {

      let book = tempList[tabNumber].book;
      let chapter = tempList[tabNumber].chapter;

      if (book > 0 && chapter > 0) {

        let updatedTabVerseListNewItem = resetHasNote(tempList[tabNumber]);  

        try {

          const httpPostData = {
            Credential: credential,
            BibleVersion: 'CUNP',
            Book: book,
            Chapter: chapter
          };
          const url = API_BASE_URL + 'api/VerseList/HasNote2/Get/';
          //dispatch(setLoading4Home(true));
          const response = await axios.post(url, httpPostData);

          response.data.map((verse, index) => (
            updatedTabVerseListNewItem.verses[verse-1].hasNote = true
          ))

          const newTabVerseListNewItem = { ...tempList[tabNumber], verses: updatedTabVerseListNewItem.verses };
          tempList = replaceTabVerseListNewItem(tempList, tabNumber, newTabVerseListNewItem);

        } catch (error) {
          console.log(error);
          if (error.response.status === 401) unauthorized();
        } finally {
          // dispatch(setLoading4Home(false)); // Set loading to false after fetching    
        }  
      } 

    }   

    if (debug) {
      let details = '';
      postLogListItem({Credential: credential, FunctionName: 'getHasNoteVersesAll', ComponentName: componentName, Details: details});
    }  
    // tempList = resetSelectedAll(tempList);         
    dispatch(setTabVerseListNew(tempList));
    //dispatch(setLoading4Home(false)); // Set loading to false after fetching    
  }  
  
  const getSearchResultVerseList = async (httpPostData, componentName) => {
    //dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('getSearchResultVerseList')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'getSearchResultVerseList', ComponentName: componentName, Details: null});
    try {

      const postData = {
        Credential: credential,
        Value: httpPostData.Value,
        SearchScopeID: httpPostData.SearchScopeID,
        SearchCriteriaExcludedList: httpPostData.SearchCriteriaExcludedList,
        PageNumber: pageNumberVerseSearch,
        PageSize: userListItem.VerseSearchResultPerPage,
      }
      const url = API_BASE_URL + 'api/VerseList/SearchCriteria/Get/';
      dispatch(setLoading4Home(true));
      const response = await axios.post(url, postData);
      dispatch(setSearchResultVerseList(response.data)); 

      if (debug) {
        let details = `pageNumber: ${pageNumberVerseSearch}; value: ${httpPostData.Value}`;
        postLogListItem({Credential: credential, FunctionName: 'getSearchResultVerseList', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      dispatch(setLoading4Home(false)); // Set loading to false after fetching
    }  
  }  
  
  const getSearchCriteriaListItem = async (componentName) => {
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'getSearchCriteriaListItem', ComponentName: componentName, Details: null});
    try {

      const httpPostData = {
        Credential: credential,
        SearchCriteria: searchString
      };
      const url = API_BASE_URL + 'api/SearchCriteriaListItem/Get/';
      //dispatch(setLoading4Home(true));
      const response = await axios.post(url, httpPostData);
      dispatch(setSearchCriteriaListItem(response.data));
      let searchScopeID = response.data.SearchScopeID === null ? 67 : response.data.SearchScopeID;
      dispatch(setSearchScopeListItemSelected(searchScopeID));

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'getSearchCriteriaListItem', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false)); // Set loading to false after fetching      
    }
  }   
  
  const postNoteBookmarkListItem = async (componentName) => { // UserName, CreationDateTimeHK and RevisionDateTimeHK ok
    //dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('postNoteBookmarkListItem')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'postNoteBookmarkListItem', ComponentName: componentName, Details: null});
    const list = noteBookmarkVerseList.map(noteBookmarkVerseListItem => ({
        Book: noteBookmarkVerseListItem.book,
        Chapter: noteBookmarkVerseListItem.chapter,
        Verse: noteBookmarkVerseListItem.verse
    }));            
    try {

      // const credential = getCredential();
      const httpPostData = {
          Credential: credential,
          Type: 'Note',
          Title: title,
          Details: details,
          NoteBookmarkVerseList: list,
      };
      const url = API_BASE_URL + 'api/NoteBookmarkListItem/Post/';
      //dispatch(setLoading4Home(true));
      await axios.post(url, httpPostData);
      dispatch(setNoteBookmarkList({resultTotal: -1, noteBookmarkList: []}));
      switch(caller4NoteBookmarkList){
        case 'Note':
          getNoteBookmarkList('allContext');
          break;
        case 'NoteSearch':
          getNoteBookmarkList3(confirmedNoteSearchString, 'allContext');
          break;
      }  

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'postNoteBookmarkListItem', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false)); // Set loading to false after fetching       
    }
  }  
  
  const putNoteBookmarkListItem2 = async (componentName) => { // UserName, CreationDateTimeHK and RevisionDateTimeHK ok
    // dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('putNoteBookmarkListItem2')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'putNoteBookmarkListItem2', ComponentName: componentName, Details: null});
    try {

      const httpPostData = {
          Credential: credential,
          ID: noteBookmarkListItemToBeDeleted.id,
          Valid: false,
          NoteBookmarkVerseList: [],
          Updated: { Valid: true }
      };
      const url = API_BASE_URL + 'api/NoteBookmarkListItem/Put/';
      //dispatch(setLoading4Home(true));        
      await axios.put(url, httpPostData);
      dispatch(setNoteBookmarkList({resultTotal: -1, noteBookmarkList: []}));
      switch(caller4NoteBookmarkList){
        case 'Note':
          getNoteBookmarkList('allContext');
          break;
        case 'NoteSearch':
          getNoteBookmarkList3(confirmedNoteSearchString, 'allContext');
          break;
      }      

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'putNoteBookmarkListItem2', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false)); // Set loading to false after fetching        
    }
  }  
  
  const putNoteBookmarkListItem1 = async (componentName) => { // UserName, CreationDateTimeHK and RevisionDateTimeHK ok
    // dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('putNoteBookmarkListItem1')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'putNoteBookmarkListItem1', ComponentName: componentName, Details: null});
    const list = noteBookmarkVerseList.map(noteBookmarkVerseListItem => ({
        Book: noteBookmarkVerseListItem.book,
        Chapter: noteBookmarkVerseListItem.chapter,
        Verse: noteBookmarkVerseListItem.verse,
        NoteBookmarkID: noteBookmarkListItemToBeChanged.id,
    }));            
    try {

        const httpPostData = {
            Credential: credential,
            ID: noteBookmarkListItemToBeChanged.id,
            Type: 'Note',
            Title: title,
            Details: details,
            NoteBookmarkVerseList: list,
            Updated: { Title: true, Details: true }
        };
        const url = API_BASE_URL + 'api/NoteBookmarkListItem/Put/';
        //dispatch(setLoading4Home(true));
        await axios.put(url, httpPostData);
        dispatch(setNoteBookmarkList({resultTotal: -1, noteBookmarkList: []}));
        switch(caller4NoteBookmarkList){
          case 'Note':
            getNoteBookmarkList('allContext');
            break;
          case 'NoteSearch':
            getNoteBookmarkList3(confirmedNoteSearchString, 'allContext');
            break;
        }         

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'putNoteBookmarkListItem1', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false)); // Set loading to false after fetching            
    }
  } 
  
  const getNoteBookmarkList3 = async (searchCriteria, componentName) => {
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'getNoteBookmarkList3', ComponentName: componentName, Details: null});
    try {

      const postData = {
        Credential: credential,
        SearchCriteria: searchCriteria,
        PageNumber: pageNumberNoteSearch,
        PageSize: userListItem.NotePerPage,
      }
      const url = API_BASE_URL + 'api/NoteBookmarkList/Get3/';
      dispatch(setLoading4Home(true));
      const response = await axios.post(url, postData);
      const reactListItem = camelcaseKeys(response.data, { deep: true });
      if (reactListItem.noteBookmarkList.length === 0 && pageNumberNoteSearch > 0){
          dispatch(setPageNumberNoteSearch(pageNumberNoteSearch-1));
      } else {
          dispatch(setNoteBookmarkList(reactListItem));
      }    

      if (debug) {
        let details = `pageNumber: ${pageNumberNoteSearch}; searchCriteria: ${searchCriteria}`;
        postLogListItem({Credential: credential, FunctionName: 'getNoteBookmarkList3', ComponentName: componentName, Details: details});
      }         

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      dispatch(setLoading4Home(false));
    }  
  } 

  const getNoteBookmarkList = async (componentName) => {
    // dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('getNoteBookmarkList')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'getNoteBookmarkList', ComponentName: componentName, Details: null});
    try {

      // const credential = getCredential();
      const postData = {
          Credential: credential,
          PageNumber: pageNumberNote,
          PageSize: userListItem.NotePerPage,
          Book: noteBookmarkListBookChapterVerse.book,
          Chapter: noteBookmarkListBookChapterVerse.chapter,
          Verse: noteBookmarkListBookChapterVerse.verse,
      }
      const url = API_BASE_URL + 'api/NoteBookmarkList/Get2/';
      dispatch(setLoading4Home(true));
      const response = await axios.post(url, postData);
      const reactListItem = camelcaseKeys(response.data, { deep: true });
      if (reactListItem.noteBookmarkList.length === 0 && pageNumberNote > 0){
          dispatch(setPageNumberNote(pageNumberNote-1));
      } else {
          dispatch(setNoteBookmarkList(reactListItem));
      }  
      
      if (debug) {
        let details = `pageNumber: ${pageNumberNote}; book: ${noteBookmarkListBookChapterVerse.book}; chapter: ${noteBookmarkListBookChapterVerse.chapter}; verse: ${noteBookmarkListBookChapterVerse.verse}`;
        postLogListItem({Credential: credential, FunctionName: 'getNoteBookmarkList', ComponentName: componentName, Details: details});
      }         

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      dispatch(setLoading4Home(false));
    }  
  } 
  
  const getVerseReadLogList4Book = async (componentName) => {
    // dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('getVerseReadLogList4Book')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'getVerseReadLogList4Book', ComponentName: componentName, Details: null});
    try {

      const httpPostData = {
        Credential: credential,
        Book: bookChapter.book
      };
      const url = API_BASE_URL + 'api/VerseReadLogList/Get/';
      //dispatch(setLoading4Home(true));
      const response = await axios.post(url, httpPostData);
      const reactItem = camelcaseKeys(response.data, { deep: true });
      const list = reactItem.map(verseReadLogListItem => ({
        book: verseReadLogListItem.book,
        chapter: verseReadLogListItem.chapter
      }));

      dispatch(setVerseReadLogList4Book(list));

      if (debug) {
        let details = `book: ${bookChapter.book}`;
        postLogListItem({Credential: credential, FunctionName: 'getVerseReadLogList4Book', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false));         
    }
  }  
  
  const getSearchScopeList = async (componentName) => {
    // dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('getSearchScopeList')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'getSearchScopeList', ComponentName: componentName, Details: null});
    try {

      // const credential = getCredential();
      const httpPostData = {
        Credential: credential,
      };
      const url = API_BASE_URL + 'api/SearchScopeList/Get/';
      //dispatch(setLoading4Home(true));
      const response = await axios.post(url, httpPostData);
      dispatch(setSearchScopeList(response.data));

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'getSearchScopeList', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false)); // Set loading to false after fetching
    }      
  }
  
  const getVerseList4Accordion1 = async (componentName) => {
    // dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('getVerseList4Accordion1')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'getVerseList4Accordion1', ComponentName: componentName, Details: null});
    try {

        // const credential = getCredential();
        const httpPostData = {
        Credential: credential,
        BibleVersion: 'CUNP',
        Book: book4Accordion1,
        Chapter: chapter4Accordion1
        };
        const url = API_BASE_URL + 'api/VerseList/Get/';
        dispatch(setLoading4Home(true));
        const response = await axios.post(url, httpPostData);        
        const list = response.data.map(item => item.Details);
        dispatch(setVerseList4Accordion1(list));

      if (debug) {
        let details = `book: ${book4Accordion1}; chapter: ${chapter4Accordion1}`;
        postLogListItem({Credential: credential, FunctionName: 'getVerseList4Accordion1', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      dispatch(setLoading4Home(false)); // Set loading to false after fetching
    }      
  } 
  
  const getUserListItem = async (componentName) => {
    //postLogListItem({Credential: credential, FunctionName: 'getUserListItem', ComponentName: componentName, Details: null});
    try {

      const httpPostData = {
        Credential: credential,
      };
      const url = API_BASE_URL + 'api/UserListItem/Get/';
      //dispatch(setLoading4Home(true));
      const response = await axios.post(url, httpPostData);
      dispatch(setUserListItem(response.data));

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'getUserListItem', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false));          
    }      
  }

  const getVerseList = async (tabNumber, componentName) => {

    let book = tabVerseListNew[tabNumber].book;
    let chapter = tabVerseListNew[tabNumber].chapter;    
    let errorResponseStatus = 'None';

    if (book > 0 && chapter > 0) {
      try {

        dispatch(setLoading4Home(true));

        const httpPostData0 = {
          Credential: credential,
          BibleVersion: 'CUNP',
          Book: book,
          Chapter: chapter
        };
        const url0 = API_BASE_URL + 'api/VerseList/Get2/';
        const response0 = await axios.post(url0, httpPostData0);   
        const reactListItem = camelcaseKeys(response0.data, { deep: true });
        const newTabVerseListNewItem = { ...tabVerseListNew[tabNumber], verses: reactListItem.verses, read: reactListItem.read, verseTotal: reactListItem.verses.length };
        const updatedTabVerseListNew = replaceTabVerseListNewItem(tabVerseListNew, tabNumber, newTabVerseListNewItem);
        dispatch(setTabVerseListNew(updatedTabVerseListNew));

        window.scrollTo(0, 0);

        if (debug) {
          let details = `book: ${book}; chapter: ${chapter}`;
          postLogListItem({Credential: credential, FunctionName: 'getVerseList', ComponentName: componentName, Details: details});        
        }        

      } catch (error) {
        console.log(error);
        if (error.response.status === 401) unauthorized();
      } finally {
        dispatch(setLoading4Home(false)); // Set loading to false after fetching
      }
    }
    
  }

  const getBookList = async (componentName) => {
    try {

      const httpPostData = {
        Credential: credential,
      };
      const url = API_BASE_URL + 'api/BookList/Get/';
      //dispatch(setLoading4Home(true));
      const response = await axios.post(url, httpPostData);
      dispatch(setBookList(response.data)); // adjust this if your API returns data in a nested object

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'getBookList', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
        //dispatch(setLoading4Home(false));      
    }
  }

  const getHistoryList = async (componentName) => { // UserName, CreationDateTimeHK and RevisionDateTimeHK ok
    // dispatch(setCircularProgressText(circularProgressText+circularProgressTextUpdate('getHistoryList')));
    //if (debug) postLogListItem({Credential: credential, FunctionName: 'getHistoryList', ComponentName: componentName, Details: null});
    try {

      const httpPostData = {
        Credential: credential,
        TopN: userListItem.HistoryListItemTotal,
      };
      const url = API_BASE_URL + 'api/HistoryList/Get/TopN/';
      //dispatch(setLoading4Home(true));
      const response = await axios.post(url, httpPostData);
      const reactList = camelcaseKeys(response.data, { deep: true });
      //let list = response.data;
      dispatch(setHistoryList(reactList)); // adjust this if your API returns data in a nested object
      dispatch(setHistoryBookChapter({ book: reactList[historyListItemSelected].book, chapter: reactList[historyListItemSelected].chapter }));

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'getHistoryList', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
      //dispatch(setLoading4Home(false)); // Set loading to false after fetching
    }   
  }

  const postUserListItem = async (httpPostData, componentName) => {
      try {

        const url = API_BASE_URL + 'api/UserListItem/Post/';
        await axios.post(url, httpPostData);
        if (debug) {
          let details = `Email: ${httpPostData.Email}; UserName: ${httpPostData.UserName}`;
          postLogListItem({Credential: httpPostData.Credential, FunctionName: 'postUserListItem', ComponentName: componentName, Details: details});
        }  

      } catch (error) {
        console.log(error);
      } finally {

      } 
  }

  const passwordReset = async (httpPostData, componentName) => { // UserName, CreationDateTimeHK and RevisionDateTimeHK ok
    try {
      const url = API_BASE_URL + 'api/UserListItem/PasswordReset/';
      await axios.put(url, httpPostData);

      if (debug) {
        let details = `Email: ${httpPostData.Email}; Password: ${httpPostData.Password}`;
        postLogListItem({Credential: httpPostData.Credential, FunctionName: 'passwordReset', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
    }      
  }

  const putUserListItem = async (httpPostData, componentName) => { // UserName, CreationDateTimeHK and RevisionDateTimeHK ok
    try {

      const url = API_BASE_URL + 'api/UserListItem/Put/';
      await axios.put(url, httpPostData);
      getUserListItem('allContext');

      if (debug) {
        let details = '';
        postLogListItem({Credential: credential, FunctionName: 'putUserListItem', ComponentName: componentName, Details: details});
      }   

    } catch (error) {
      console.log(error);
      if (error.response.status === 401) unauthorized();
    } finally {
    }      
  }

  return (
    <allContext.Provider value={{ getTempCredential, passwordReset, verifyEmail4PasswordReset, sendEmail4SignUp, sendEmail4PasswordReset, getEmailByUsername, verifyEmail4SignUp, postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem }}>
      {children}
    </allContext.Provider>
  );

};

export const useShared = () => {
  return useContext(allContext);
};
